import Vue from "vue";
import BTableColumnFilter from "@/filters/BTableColumnFilter";
import moment from "moment";
import Helpers from "./helpers/helper";
import VueCurrencyFilter from "vue-currency-filter";

Vue.filter("bTableColumnValue", BTableColumnFilter.Value);
Vue.filter("date", (value: string) => moment(value).format("L"));
Vue.filter("time", (value: string) => moment(value).format("LT"));
Vue.filter("bool", (value: boolean) => (value ? "Sí" : "No"));
Vue.filter("sexo", (value: "M" | "F") =>
  value ? Helpers.Filters.Sexo(value) : Helpers.Filters.Empty
);
Vue.filter("estadoCivil", (value: "S" | "C") =>
  value ? Helpers.Filters.EstadoCivil(value) : Helpers.Filters.Empty
);
Vue.filter("medidaTiempoEmbarazo", (value: number) =>
  value
    ? value === 0
      ? "dias"
      : value === 1
        ? "semanas"
        : value === 2
          ? "meses"
          : Helpers.Filters.Empty
    : Helpers.Filters.Empty
);
Vue.filter("edad", (value: string) =>
  value ? Helpers.Filters.Edad(value) : Helpers.Filters.Empty
);
Vue.filter("edadText", (value: string) =>
  value ? `${Helpers.Filters.Edad(value)} años` : Helpers.Filters.Empty
);
Vue.filter("timeAgo", (value: string) =>
  value ? `${Helpers.Filters.FromNow(value)}` : Helpers.Filters.Empty
);
Vue.filter("cedula", (value: string) =>
  value ? Helpers.Filters.Cedula(value) : Helpers.Filters.Empty
);
Vue.filter("empty", (value: string) => value || Helpers.Filters.Empty);
Vue.filter("translate", (value: string) => Helpers.Filters.Translate(value));
Vue.filter('phone', function (phone: any) {
  return phone.replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
});
Vue.filter('formatDate', function (value: any) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})
Vue.filter('emptyis', function (value: number) {
  if (value === 0) {
    return "Indefinido"
  }
})
Vue.filter('LL', function (value: any) {
  if (value) {
    return moment(String(value)).format('LL');
  }

})
Vue.filter("suspensivo",
  function (texto: any) {
    if (texto && texto.length > 29) return texto.substring(0, 29) + " ...";
    else return texto
  });
Vue.filter("suspensivoRole",
  function (texto: any) {
    if (texto && texto.length > 29) return texto.substring(0, 220) + " ...";
    else return texto
  });
Vue.filter('susp', function (value: any) {
  if (value) {
    return value.substring(0, 20) + ' ...'
  }
})
Vue.filter('suspeExpectResult', function (value: any) {
  if (value) {
    return value.substring(0, 5) + ' ...'
  }
})
Vue.filter("formatDateMY", function (value: any) {
  if (value) {
    return moment(String(value)).format("MM/YYYY");
  }
});
Vue.filter("date_month", function (value: any) {
  if (value) {
    return moment(String(value)).format("MMMM - YYYY");
  }
});

Vue.use(VueCurrencyFilter, {
  symbol: "",
  thousandsSeparator: ",",
  fractionCount: 2,
  fractionSeparator: ".",
  symbolPosition: "front",
  symbolSpacing: true
});
